import { render } from "./log-info-list.vue?vue&type=template&id=64e0ac9a&ts=true"
import script from "./log-info-list.vue?vue&type=script&lang=ts"
export * from "./log-info-list.vue?vue&type=script&lang=ts"

import exportComponent from "/srv/bimgx-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__